import React from "react";
import "./App.css";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation  } from "react-router-dom";

import Footer from "./components/footer";
import Header from "./components/header";
import AuthGate from "./components/AuthGate";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserProvider } from "./contexts/UserContext";
import SignInBanner from "./components/SignInBanner";
import AddRecipe from "./pages/AddRecipe";
import EditRecipe from "./pages/EditRecipe";
import ListRecipes from "./pages/ListRecipes";
import SignIn from "./pages/SignIn";
import ViewRecipe from "./pages/ViewRecipe";


function Layout() {
  const location = useLocation();
  const hideOn = ["/signin"]; // add more like "/signup", "/forgot" if needed
  const hideBanner = hideOn.includes(location.pathname);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      {!hideBanner && <SignInBanner />}  {/* 👈 condition */}
      <main className="container flex-grow py-16 print:p-0">
        <Routes>
          <Route path="/" element={<Navigate to="/recipes" />} />
          <Route path="/recipes" element={<ListRecipes />} />
          <Route path="/recipe/:id" element={<ViewRecipe />} />
          <Route
            path="/recipe/:id/edit"
            element={
              <ProtectedRoute>
                <EditRecipe />
              </ProtectedRoute>
            }
          />
          <Route
            path="/recipe/add"
            element={
              <ProtectedRoute>
                <AddRecipe />
              </ProtectedRoute>
            }
          />
          <Route path="/signin" element={<SignIn />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <UserProvider>
      <Router>
        <AuthGate>
          <Layout />
        </AuthGate>
      </Router>
    </UserProvider>
  );
}
